import React, { useMemo } from 'react';
import CodeSparkThemedTypography from '../../../../../components/elements/CodeSparkThemedTypography';
import {
  ColumnCenter,
  SectionPaddingVertical,
  SectionWidth,
} from '../../../../../components/global/Layout';
import CtaButtonContainer from '../../../../../components/elements/CtaButton/CtaButtonContainer';
import CtaButton from '../../../../../components/elements/CtaButton';
import { useExperimentContext } from '../../../../../experiments/context';
import { getPlanLabelData } from '../../../../../subscriptionPlans/planLabelData';
import { usePlanSelector } from '../hooks';
import SubscriptionPlan from './SubscriptionPlan';
import PlansInclude from './PlansInclude';
import styles from './PlanSelectorV3.module.css';

export function SelectedPlanLegal({ selectedOffer }) {
  return (
    <CodeSparkThemedTypography variant="subtitle3" className={styles.planSelectorBillingLegal}>
      ${selectedOffer.price.toFixed(2)} charged after {selectedOffer.trialDurationDays}-day free
      trial.{' '}
      <span>
        <b>Cancel anytime.</b>
      </span>
    </CodeSparkThemedTypography>
  );
}

export default function PlanSelectorV3({
  title,
  valueProps,
  planOptionsData,
  selectedOffer,
  onCtaClick,
  ctaLabel,
}) {
  const { handleSelectPlan, handleCtaNavigate } = usePlanSelector({
    onCtaClick,
    navigateOnSelect: false,
  });
  const {
    experiments: { differentPlanTrials },
  } = useExperimentContext();
  const planTrialLabels = selectedOffer ? getPlanLabelData(selectedOffer) : {};
  const { trialQuantity, trialInterval } = planTrialLabels;
  const selectPlanHeader = differentPlanTrials
    ? 'Select a plan below and start your free trial'
    : `Select a plan below and start your ${trialQuantity}-${trialInterval} free trial`;

  return (
    <SectionWidth className={styles.planSelectorSection}>
      <SectionPaddingVertical>
        <ColumnCenter>
          <CodeSparkThemedTypography
            variant="h2"
            align="center"
            className={styles.planSelectorTitle}
          >
            {title}
          </CodeSparkThemedTypography>

          <PlansInclude valueProps={valueProps} />

          <CodeSparkThemedTypography
            variant="h4"
            align="center"
            className={styles.planSelectorSubtitle}
          >
            {selectPlanHeader}
          </CodeSparkThemedTypography>

          <div className={styles.planSelectorOptionsContainer}>
            {planOptionsData.map(planData => {
              const {
                plan: { planId },
              } = planData;

              return (
                <SubscriptionPlan
                  key={planId}
                  selected={selectedOffer && selectedOffer.planId === planId}
                  onClick={e => handleSelectPlan(e, planId)}
                  {...planData}
                />
              );
            })}
          </div>

          <CtaButtonContainer className={styles.ctaButtonContainer}>
            <CtaButton onClick={handleCtaNavigate} type="primary2" fullWidthMobile>
              {ctaLabel}
            </CtaButton>
          </CtaButtonContainer>

          {selectedOffer && <SelectedPlanLegal selectedOffer={selectedOffer} />}
        </ColumnCenter>
      </SectionPaddingVertical>
    </SectionWidth>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/V3/index.js